export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

export function formatPercent(value, decimalPlaces) {
    let floatValue = 0;
    // get the float value from the tooltipItem
    if (typeof (value) == 'number') {
        floatValue = value;
    } else {
        floatValue = parseFloat(value);
    }

    if (floatValue == 0 || floatValue == 100) {
        return ` ${floatValue}%`;
    }
    return ` ${floatValue.toFixed(decimalPlaces)}%`;
}

export const colors = {
    blue: '#073F74',
    green: '#7A9444',
    red: '#CE4932',
    yellow: '#E28627',
    brown: '#420A0D',
    darkblue: '#1A2E4C',
    lightblue: '#6597D1',
    orange: '#E39F42',
    darkred: '#4F1611',
    pink: '#C24F92',
    gray: '#E8EEF1',
    darkgray: '#A5B2C4'
}



export function wrapText(context, text, x, y, line_width = 100, line_height = 18) {
    var line = '';
    var paragraphs = text.split('\n');
    for (var i = 0; i < paragraphs.length; i++) {
        var words = paragraphs[i].split(' ');
        for (var n = 0; n < words.length; n++) {
            var testLine = line + words[n] + ' ';
            var metrics = context.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > line_width && n > 0) {
                context.fillText(line, x, y);
                line = words[n] + ' ';
                y += line_height;
            }
            else {
                line = testLine;
            }
        }
        context.fillText(line, x, y);
        y += line_height;
        line = '';
    }
}

export function fixCIP(name) {
    if (name == 'Remainder') {
        return "Other";
    }
    return toTitleCase(name).substring(0, name.length - 1);
}


function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    ).replace('And', 'and');
}


export function slugify(text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')        // Replace spaces with -
        .replace(/[^\w\-]+/g, '')    // Remove all non-word chars
        .replace(/\-\-+/g, '-')      // Replace multiple - with single -
        .replace(/^-+/, '')          // Trim - from start of text
        .replace(/-+$/, '');         // Trim - from end of text
}